import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosCategoriesPage } from './cronos-categories';

@NgModule({
  declarations: [
    CronosCategoriesPage,
  ],
  imports: [
    IonicPageModule.forChild(CronosCategoriesPage),
  ],
})
export class CronosCategoriesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-categories/cronos-categories.module.ts